import { createSlice, current } from '@reduxjs/toolkit';
import * as _ from 'lodash';
import {
  MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
  PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD,
} from 'src/constants';
import {
  getNetworksList as getNetworksListPC,
  searchProvidersPC,
  getPriceComaperFilters,
  getHealthProcedureCodes,
} from './api-calls/priceCompare';
import moment from 'moment';

const INITIAL_STATE = {
  providerType: 'doctor',
  address: '',
  //usercoordinates: {
  //lat: 32.47,
  //lng: -99.7
  //},
  searchParamsForUI: {},
  searchProviderParams: {
    pagesize: 10,
    pagenumber: 1,
    Network: 'all-plan-networks',
    selectedNetwork: {
      label: 'All Plan Networks',
      value: 'all-plan-networks',
      AllowForPriceComparison: 'Y',
      ProviderDirectory: 'I',
      ExternalName: '',
    },
    sortby: 'Distance',
    sortdirection: 'asc',
    filters: {
      maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
      Gender: '',
      Provider: 'doctor',
    },
    AcceptingNewPatients: false,
  },
  networksList: [
    { label: 'All Plan Networks', value: 'all-plan-networks' },
    {
      label: 'All - Including Out of Network Providers',
      value: 'all-include-out-of-network',
    },
  ],
  isNetworksListFetched: false,
  isSearchingProviders: false,
  isSearchingProvidersFromResetFilters: false,
  showAllFiltersPanel: false,
  showFilterBar: false,
  filtersValuesList: {},
  searchProviderFiltersChanged: false,
  searchProvidersSortingChanged: false,
  searchResults: { pagination: null, data: null },
  noResultsFound: false,
  showServerError: false,
  selectedCheckedItems: [],
  selectedCheckedRowData: [],
  HealthProcedureCodes: [],
  isHealthProcedureCodesFetched: false,
  recentSearchList: [],
  networkTierList: [],
  showCostClickCount: 0,
  isUpdateTimeExpired: false,
  showCostClickTimestamp: null,
  showCostClickTimeThreshold:
    PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
  showCostClickNumThreshold: PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.clicks,
};

export const priceCompareSlice = createSlice({
  name: 'priceCompare',
  initialState: INITIAL_STATE,
  reducers: {
    setProviderType: (state, action) => {
      state.providerType = action.payload;
      const { selectedNetwork } = state.searchProviderParams;
      state.searchProviderParams = {
        ...INITIAL_STATE.searchProviderParams,
        selectedNetwork,
      };
      //state.searchProviderParams = INITIAL_STATE.searchProviderParams;
      state.searchResults = INITIAL_STATE.searchResults;
      state.showFilterBar = INITIAL_STATE.showFilterBar;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    setNetworkTierList: (state, action) => {
      state.networkTierList = action.payload;
    },
    setSearchProviderParams: (state, action) => {
      state.searchProviderParams = {
        ...state.searchProviderParams,
        ...action.payload,
      };
    },
    setSearchParamsForUI: (state, action) => {
      state.searchParamsForUI = {
        ...state.searchParamsForUI,
        ...action.payload,
      };
    },
    setSearchProviderSorting: (state, action) => {
      state.searchProviderParams.sortby = action.payload.sortby;
      state.searchProviderParams.sortdirection = action.payload.sortdirection;
      state.searchProvidersSortingChanged = true;
    },
    setShowAllFiltersPanel: (state, action) => {
      state.showAllFiltersPanel = action.payload;
    },
    setSearchProviderFilters: (state, action) => {
      state.searchProviderParams.filters = {
        ...state.searchProviderParams.filters,
        ...action.payload,
      };
      state.searchProviderFiltersChanged = true;
    },
    setFilterChangeStatus: (state, action) => {
      state.searchProviderFiltersChanged = action.payload || false;
    },
    resetSortingChangeStatus: (state, action) => {
      state.searchProvidersSortingChanged = action.payload || false;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setRecentSearchList: (state, action) => {
      state.recentSearchList = action.payload;
    },
    resetSearchParams: (state, action) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        if (key !== 'networksList') {
          state[key] = INITIAL_STATE[key] || null;
        }
      });
    },
    resetRecentSearchList: (state, action) => {
      state.recentSearchList = INITIAL_STATE.recentSearchList;
    },
    resetSearchProviderFilters: (state, action) => {
      state.isSearchingProvidersFromResetFilters = true;
      const initialSearchProviderParam = JSON.parse(
        JSON.stringify(INITIAL_STATE.searchProviderParams),
      );
      initialSearchProviderParam.Network = state.searchProviderParams.Network;
      initialSearchProviderParam.selectedNetwork =
        state.searchProviderParams.selectedNetwork;
      //state.searchProviderParams.selectedNetwork = {
      //label: 'All Plan Networks',
      //value: 'all-plan-networks',
      //AllowForPriceComparison: 'Y',
      //ProviderDirectory: 'I',
      //ExternalName: '',
      //};
      initialSearchProviderParam.filters.Provider = state.providerType;
      if (state.searchProviderParams.DoctorByName) {
        initialSearchProviderParam.DoctorByName =
          state.searchProviderParams.DoctorByName;
      }
      if (state.searchProviderParams.DoctorByType) {
        initialSearchProviderParam.DoctorByType =
          state.searchProviderParams.DoctorByType;
      }
      if (state.searchProviderParams.speciality) {
        initialSearchProviderParam.speciality =
          state.searchProviderParams.speciality;
      }
      if (state.searchProviderParams.facilityname) {
        initialSearchProviderParam.facilityname =
          state.searchProviderParams.facilityname;
      }

      state.searchProviderParams = initialSearchProviderParam;
      //state.searchProviderParams.AcceptingNewPatients = false;
      //state.searchParamsForUI = {};
      state.selectedCheckedItems = [];
      state.selectedCheckedRowData = [];
      state.searchProviderFiltersChanged = true;
      state.showAllFiltersPanel = false;

      const { filters, ...restValues } = state.searchParamsForUI;

      state.searchParamsForUI = {
        ...state.searchParamsForUI,
        filters: { ...restValues },
      };
    },
    searchProviderFiltersInitial: (state, action) => {
      state.searchProviderParams.filters =
        INITIAL_STATE.searchProviderParams.filters;
      state.searchProviderFiltersChanged = false;
      state.selectedCheckedItems = [];
      state.selectedCheckedRowData = [];
    },
    resettingMoreFilters: (state, action) => {
      //state.searchProviderParams = INITIAL_STATE.searchProviderParams;
      state.isSearchingProvidersFromResetFilters = true;
      const initialSearchProviderParam = JSON.parse(
        JSON.stringify(INITIAL_STATE.searchProviderParams),
      );
      initialSearchProviderParam.Network = state.searchProviderParams.Network;
      initialSearchProviderParam.selectedNetwork =
        state.searchProviderParams.selectedNetwork;
      //state.searchProviderParams.selectedNetwork = {
      //label: 'All Plan Networks',
      //value: 'all-plan-networks',
      //AllowForPriceComparison: 'Y',
      //ProviderDirectory: 'I',
      //ExternalName: '',
      //};
      initialSearchProviderParam.filters.Provider = state.providerType;
      //state.searchProviderParams.filters.Provider;
      if (state.searchProviderParams.DoctorByName) {
        initialSearchProviderParam.DoctorByName =
          state.searchProviderParams.DoctorByName;
      }
      if (state.searchProviderParams.DoctorByType) {
        initialSearchProviderParam.DoctorByType =
          state.searchProviderParams.DoctorByType;
      }
      if (state.searchProviderParams.speciality) {
        initialSearchProviderParam.speciality =
          state.searchProviderParams.speciality;
      }
      if (state.searchProviderParams.facilityname) {
        initialSearchProviderParam.facilityname =
          state.searchProviderParams.facilityname;
      }

      state.searchProviderParams = initialSearchProviderParam;
      //state.searchProviderParams.AcceptingNewPatients = false;
      state.searchProviderFiltersChanged = true;
      state.selectedCheckedItems = [];
      state.selectedCheckedRowData = [];
      state.showAllFiltersPanel = false;
      const { filters, ...restValues } = state.searchParamsForUI;

      state.searchParamsForUI = {
        ...state.searchParamsForUI,
        filters: { ...restValues },
      };
    },
    resetNetworkList: (state, action) => {
      state.networksList = INITIAL_STATE.networksList;
    },
    resetSearchResults: (state, action) => {
      state.searchResults = INITIAL_STATE.searchResults;
    },
    setSelectedCheckedItems: (state, action) => {
      state.selectedCheckedItems = action.payload;
    },
    reetSelectedCheckedItems: (state, action) => {
      state.selectedCheckedItems = [];
    },

    setSelectedCheckedRowData: (state, action) => {
      state.selectedCheckedRowData = action.payload;
    },
    setShowCostClickCount: (state) => {
      state.showCostClickCount = state.showCostClickCount + 1;
    },
    resetShowCostClickCount: (state) => {
      state.showCostClickCount = 0;
      state.isUpdateTimeExpired = false;
    },

    setShowCostClickTimestamp: (state) => {
      if (state.showCostClickTimestamp === null) {
        state.showCostClickTimestamp =
          moment().unix() +
          parseInt(PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds);
      } else {
        if (
          state.showCostClickTimestamp <
            moment().unix() +
              parseInt(
                PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
              ) &&
          state.isUpdateTimeExpired === false
        ) {
          state.showCostClickTimestamp =
            moment().unix() +
            parseInt(
              PRICE_COMPARISON_SHOW_COST_CLICK_THRESHOLD.time_in_seconds,
            );
          state.isUpdateTimeExpired = true;
        }
      }
    },
    resetShowCostClickTimestamp: (state) => {
      state.showCostClickTimestamp = null;
      state.isUpdateTimeExpired = false;
    },
  },
  extraReducers: {
    [getNetworksListPC.fulfilled]: (state, action) => {
      const listOfNetworks = action.payload.data.Response.ListOfNetworks;
      if (listOfNetworks.length === 1) {
        state.searchProviderParams.Network = listOfNetworks[0];
        state.networksList = [
          ...listOfNetworks.map((val) => {
            return { label: val, value: val };
          }),
          state.networksList[1],
        ];
      } else {
        state.networksList = [
          ...state.networksList,
          ...listOfNetworks.map((val) => {
            return { label: val, value: val };
          }),
        ];
      }
      state.isNetworksListFetched = true;
    },
    [getHealthProcedureCodes.fulfilled]: (state, action) => {
      const list = action.payload.data.Response.HealthProcedureCodes;
      state.HealthProcedureCodes = list.map((val) => {
        return { label: val.Abbreviation, value: val.Code };
      });
      state.isHealthProcedureCodesFetched = true;
    },
    [searchProvidersPC.pending]: (state, action) => {
      //const {arg : {meta}} = action;
      state.isSearchingProviders = true;
      state.showFilterBar = false;
      state.noResultsFound = false;
      state.showServerError = false;
      if (!action.meta.arg?.pagenumber) {
        state.isSearchingProvidersFromResetFilters = true;
        state.searchResults = { pagination: null, data: null };
      }
      //state.searchResults = { pagination: null, data: null };
    },
    [searchProvidersPC.fulfilled]: (state, action) => {
      const response = action.payload.data.Response;
      if (response?.Pagination?.PageNumber >= 0) {
        response.Pagination.PageNumber += 1;
      }

      if (action.payload.isCignaRoasterSearch) {
        if (!action.payload.searchParamsPageNumber) {
          state.searchResults = {
            pagination: response?.Pagination,
            data: response.data,
          };
        } else {
          //FacilityID
          const uniqueKey =
            current(state).searchProviderParams.filters.Provider === 'facility'
              ? 'FacilityID'
              : 'PhysicianID';
          const ids = new Set(
            state.searchResults.data?.map((d) => d[uniqueKey]),
          );
          state.searchResults = {
            pagination: response?.Pagination,
            data: current(state)?.searchResults?.data
              ? [
                  ...state.searchResults.data,
                  ...response.data.filter((d) => !ids.has(d[uniqueKey])),
                ]
              : response.data
              ? response.data
              : [],
          };
        }
      } else {
        state.searchResults = {
          pagination: response?.Pagination,
          data: response.data,
        };
      }

      state.isSearchingProviders = false;

      if (
        _.isEqual(
          state.searchProviderParams.filters,
          INITIAL_STATE.searchProviderParams.filters,
        )
      ) {
        state.showFilterBar = response?.data?.length > 0 ? true : false;
      } else {
        state.showFilterBar =
          current(state).searchProviderParams.selectedNetwork
            ?.ProviderDirectory === 'R' && response?.data?.length === 0
            ? false
            : true;
        //state.showFilterBar = true;
      }
      state.noResultsFound = response?.data?.length > 0 ? false : true;
      state.isSearchingProvidersFromResetFilters = false;
    },
    [searchProvidersPC.rejected]: (state, action) => {
      state.showFilterBar = false;
      state.isSearchingProviders = false;
      state.isSearchingProvidersFromResetFilters = false;
      state.searchResults = [];
      if (
        action?.error?.message?.includes('404') ||
        action?.error?.message?.includes('400')
      ) {
        state.noResultsFound = true;
      } else {
        state.showServerError = true;
      }
    },
    [getPriceComaperFilters.pending]: (state, action) => {},
    [getPriceComaperFilters.fulfilled]: (state, action) => {
      const resp = action.payload.data.Response;
      if (resp && resp !== undefined) {
        Object.keys(resp).forEach((key) => {
          if (['UniqueLanguages', 'UniqueSpecialities'].includes(key)) {
            resp[key] = resp[key].map((ele) => {
              return { label: ele, value: ele };
            });
          }
        });
      }
      state.filtersValuesList = {
        Specialities: resp.UniqueSpecialities,
        ListOfDoctorLanguages: resp.UniqueLanguages,
      };
      //state.filtersValuesList = resp;
    },
    [getPriceComaperFilters.rejected]: (state, action) => {
      state.filtersValuesList = {};
    },
  },
});

export const {
  setSearchProviderParams,
  setAddress,
  setProviderType,
  setSearchResults,
  setShowAllFiltersPanel,
  setSearchProviderFilters,
  resetSearchParams,
  setFilterChangeStatus,
  resetSearchProviderFilters,
  setSearchProviderSorting,
  resetSortingChangeStatus,
  resetNetworkList,
  resetSearchResults,
  searchProviderFiltersInitial,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
  setSearchParamsForUI,
  reetSelectedCheckedItems,
  resettingMoreFilters,
  setRecentSearchList,
  resetRecentSearchList,
  setNetworkTierList,
  setShowCostClickCount,
  resetShowCostClickCount,
  setShowCostClickTimestamp,
  resetShowCostClickTimestamp,
} = priceCompareSlice.actions;

export default priceCompareSlice.reducer;
